/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import StoreRepository from '../../repositories/Admin/Stores/StoreRepository';
import { createRestSlice } from '../../utils/RestSlice';

const storesRestSlice = createRestSlice({
  resource: 'store',
  repository: StoreRepository,
  slices: ['loadStores'],
});

const initialState = {
  ...storesRestSlice.initialState,
};

const storesSlice = createSlice({
  name: 'stores',
  initialState,
  reducers: {
    ...storesRestSlice.reducers,
  },
});

export default storesSlice.reducer;

export const storesRestHooks = storesRestSlice.hooks(storesSlice, [
  'admin',
  'StoresSlice',
]);
